import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '../../../appshared/invoice/item/item.service';
import { TranslateService } from '@ngx-translate/core';
import { CartService } from '../../../appshared/invoice/cart.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { MatTableDataSource } from '@angular/material/table';
import { ItemModule, ViewItem } from '../../../appshared/invoice/item/item.module';
import { AppLoaderService } from '../../../common/service/app-loader/app-loader.service';
import { CategoryService } from '../../../appshared/masters/category/category.service';
import { CategoryModule } from '../../../appshared/masters/category/category.module';
import { TagService } from '../../../appshared/invoice/tag/tag.service';
import { TagModule } from '../../../appshared/invoice/tag/tag.module';

@Component({
  selector: 'app-occasion-shop',
  templateUrl: './occasion-shop.component.html',
  styleUrls: ['./occasion-shop.component.scss']
})
export class OccasionShopComponent {

    public SelectedLanguage: string = "en";
    private sub: any;
    closeModal: any;
    public apiURL: string = "";
    ComID: number = 2;

    constructor(
        public router: Router, private service: TagService, private route: ActivatedRoute, private servItem: ItemService, private loader: AppLoaderService, public translate: TranslateService,

        private cartService: CartService, private toastr: ToastrService
    ) {
        if (this.translate.currentLang != undefined) {

            this.SelectedLanguage = this.translate.currentLang;
        }

    }
    imgTitle: string = 'assets/img/page-title1.jpg';
    ngOnInit(): void {

        this.route.params.subscribe(params => {
            /*    if (+params['catID'] > 0) {*/
            try {
                this.Cid = +params['catID'];
                if (this.Cid.toString() == 'NaN') {
                    this.Cid = 0;
                }

            } catch (e) {
                this.Cid = 0;
                this.CategoryName = "";
            }
            try {
                this.SCid = +params['scatID'];
                if (this.SCid.toString() == 'NaN') {
                    this.SCid = 0;
                }

            } catch (e) {
                this.SCid = 0;
                this.CategoryName = "";
            }
            try {
                this.serachName = params['serachName'];
                if (this.serachName.toString() == 'NaN') {
                    this.serachName = "";
                }

            } catch (e) {
                this.serachName = "";
            }
            
            this.fillTags();
        });


        //this.sub = this.route.params.subscribe((params: { [x: string]: any; }) => {
        //    if (+params['catID'] > 0) {
        //        this.Cid = +params['catID'];
        //    }
        //});
        
        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/';
        // this.FillCategory();
    }


    sortType: string = "Default";
    Cid: number = 0;
    SCid: number = 0;
    CategoryName?: string = "";
    serachName?: string = "";

    currentDate = new Date();

    onClickTag(tagId) {

        this.router.navigate(['shop', { tagId: tagId }]);
    }

    public dataSourceTag = new MatTableDataSource<TagModule>();

    datas: any;

    //////////////////////////////////////////


    onSortChange(event: any) {
        this.sortType = event.target.value;
        this.fillTags();
    }

    fillTags() {
        //    this.loader.open();
        this.service.getService(this.ComID)
            .subscribe((res: TagModule[]) => {



                this.dataSourceTag.data = res;


            },
                (err: any) => {
                    console.log(err);
                });
    }

    onCategoryChange(catID: number, CatName: string | undefined, CatNameAr: string | undefined) {

        this.Cid = catID;

        if (this.SelectedLanguage != "en") {

            this.CategoryName = CatNameAr;
        }
        else {

            this.CategoryName = CatName;
        }

        this.fillTags();
    }




    addToCart(itemM: ItemModule) {


        this.loader.open();

        var price = itemM.salesPrice;
        if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
            price = itemM.webDiscountAmount;
        }


        var product: ViewItem = {


            inItemID: itemM.inItemID,
            name: itemM.webNameEn,
            nameAr: itemM.webNameAr,
            salesPrice: itemM.salesPrice,
            barcode: itemM.barcode,
            inCategoryID: itemM.inCategoryID,
            description: itemM.description,
            inUnitID: itemM.inUnitID,
            photoPath: itemM.photoPath,
            itemCode: itemM.itemCode,
            unitName: itemM.unitName,
            systemCode: itemM.systemCode,
            categoryNameAr: itemM.categoryNameAr,
            descriptionAr: itemM.descriptionAr,
            categoryName: itemM.categoryName,

            saleTaxPercentage: itemM.saleTaxPercentage,
            isViewWeb: itemM.isViewWeb,
            webDiscountFromDate: itemM.webDiscountFromDate,
            webDiscountToDate: itemM.webDiscountToDate,
            webDiscountAmount: itemM.webDiscountAmount,
            activateWebDiscount: itemM.activateWebDiscount,
            unitNameAr: itemM.unitNameAr,
            webDiscountPercentage: itemM.webDiscountPercentage,
            wholesalePrice: itemM.webDiscountPercentage,

            cartQuantity: 1,
            cartPrice: price

        };



        this.cartService.addToCart(product, 1);

        this.loader.close();

        var transR = this.translate.instant('Your_product_added_to_the_cart');
        this.toastr.success(transR, '');

        //this.servItem.getItemBranchNoSales(this.ComID, itemM.inItemID, 1)
        //    .subscribe(res => {

        //        this.loader.close();
        //        if (+res >= 1) {



        //            var price = itemM.salesPrice;
        //            if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
        //                price = itemM.webDiscountAmount;
        //            }

        //            var product: ViewItem = {


        //                inItemID: itemM.inItemID,
        //                name: itemM.webNameEn,
        //                nameAr: itemM.webNameAr,
        //                salesPrice: itemM.salesPrice,
        //                barcode: itemM.barcode,
        //                inCategoryID: itemM.inCategoryID,
        //                description: itemM.description,
        //                inUnitID: itemM.inUnitID,
        //                photoPath: itemM.photoPath,
        //                itemCode: itemM.itemCode,
        //                unitName: itemM.unitName,
        //                systemCode: itemM.systemCode,
        //                categoryNameAr: itemM.categoryNameAr,
        //                descriptionAr: itemM.descriptionAr,
        //                categoryName: itemM.categoryName,

        //                saleTaxPercentage: itemM.saleTaxPercentage,
        //                isViewWeb: itemM.isViewWeb,
        //                webDiscountFromDate: itemM.webDiscountFromDate,
        //                webDiscountToDate: itemM.webDiscountToDate,
        //                webDiscountAmount: itemM.webDiscountAmount,
        //                activateWebDiscount: itemM.activateWebDiscount,
        //                unitNameAr: itemM.unitNameAr,
        //                webDiscountPercentage: itemM.webDiscountPercentage,
        //                wholesalePrice: itemM.webDiscountPercentage,

        //                cartQuantity: 1,
        //                cartPrice: price


        //            };

        //            this.cartService.addToCart(product, 1);

        //            var transR = this.translate.instant('Your_product_added_to_the_cart');
        //            this.toastr.success(transR, '');


        //        }
        //        else {

        //            var transR = this.translate.instant('This_Item_Out_of_Stock');
        //            this.toastr.warning(transR, '');
        //        }

        //    },
        //        (err: any) => {
        //            console.log(err);
        //        });
    }



    onClickItem(ItemId: number) {
        this.router.navigate(['product-details', { ItemId: ItemId }]);
    }
}
